import React from 'react';
import { Placing, SCTeam, SCTeamWithCaptainsVice } from '../../types/types';
import styled from '@emotion/styled';
import { Paper } from '@mui/material';
import CaptainCard from '../Cards/CaptainCard';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const CardNumber = styled.b`
    font-size: 1.5rem;
    @media (min-width: 1024px) {
        font-size: 1.5rem ;
    }
`

const CardLabel = styled.span`
    font-size: 1rem;
    line-height: 1;
    @media (min-width: 1024px) {
        font-size: 1rem;
    }
`

const SingleTeamHeader = styled(Paper)`
    padding: 1rem;
    margin-bottom: 1rem;
    text-align: left;
    display: flex;
    column-gap: 2rem;
    align-items: center;
    @media(max-width: 800px) {
        flex-direction: column;
    }

    @media(min-width: 800px) {
        
    }
`;

const MetricsContainer = styled.div`
    display: flex;
    column-gap: 2rem;
    flex-wrap: wrap;
    @media(max-width: 800px) {
        flex-direction: row;
        justify-content: center;
        row-gap: 1rem;
        .rank-metric, .rd-metric {
            width: 40%;
        }
        .price-metric {
            width: 100%;
        }
    }
`

const CaptainsContainer = styled.div`
    display: flex;
    column-gap: 1rem;
    
    @media(max-width: 800px) {
        margin-top: 2rem;
    }

    @media(min-width: 800px) {
        margin-left: auto;
    }
`;

export interface Props {
    team: SCTeamWithCaptainsVice;
    totalrank: number;
    rdrank: number;
    lastPlacing: Placing;
    showCaptains?: boolean;
}

const SingleSCTeamHeader = ({team,totalrank,rdrank, lastPlacing, showCaptains=true}:Props) => {
    let placingObject = {
    };
    if (team.placings.length > 0) {
        let lastplacing = team.placings[team.placings.length - 1];
        let secondplacing = team.placings[team.placings.length - 2];
        
        if (lastplacing && secondplacing) {
            // {
            //     "team": {
            //         "name": "Willzyy",
            //         "teamid": "42871"
            //     },
            //     "round": 13,
            //     "price": 2257100,
            //     "price_change": 166800,
            //     "position": 20499,
            //     "round_position": 1,
            //     "season": "2021",
            //     "position_change": 0,
            //     "rd_position_change": 0
            // }

            placingObject = {
                team: lastplacing.team,
                position_change:  secondplacing.position - lastplacing.position,
                rd_position_change: secondplacing.round_position - lastplacing.round_position,
                ...lastplacing,
            }
        } else {
            placingObject = {
            position_change: 0,
            rd_position_change: 0,
            ...lastplacing
            }
        }
    }
    console.log("PLACING OBJECT: ", placingObject,team);
    let position_change = 0;
    let rd_position_change
    if (!placingObject) {

    }
    return <SingleTeamHeader elevation={5}>
        <h4>{team.team.name}</h4>
        <MetricsContainer >
            <div className="rank-metric" style={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: 'center'}}>
                <CardNumber style={{color: placingObject.position_change > -1 ? 'green' : 'red'}}>
                    {placingObject.position}&nbsp;({placingObject.position_change > 0 ? '+' : ''}{placingObject.position_change})
                </CardNumber>
                <CardLabel>Season Rank</CardLabel>
            </div>
            <div className="rd-metric" style={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: 'center'}}>
                <CardNumber style={{color: placingObject.rd_position_change > -1 ? 'green' : 'red'}}>
                    {placingObject.round_position}
                    &nbsp;({placingObject.rd_position_change > 0 ? '+' : ''}{placingObject.rd_position_change})
                </CardNumber>
                <CardLabel>Last Rd Rank</CardLabel>
            </div>
            <div className="price-metric" style={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: 'center'}}>
                <CardNumber style={{color: placingObject?.price_change > -1 ? 'green' : 'red'}}>
                    {placingObject.price?.toLocaleString('en-US', { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0})}
                    &nbsp;({placingObject.price_change > 0 ? '+' : ''}{placingObject.price_change?.toLocaleString('en-US', { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0})})
                </CardNumber>
                <CardLabel>Price</CardLabel>
            </div>
        </MetricsContainer>
        {showCaptains? 
        <CaptainsContainer>
            <CaptainCard player={team.team.captain.player} played={"capt"}/>
            <CaptainCard player={team.team.vice.player} />
        </CaptainsContainer>
        : null }
    </SingleTeamHeader>
}

export default SingleSCTeamHeader;